// 食事写真解析サービス
app.factory('foodPhotoAnalysis', function($q, analysisKeyword, analysisConfig) {
    var _apiEndpoint;
    var _serverUrl;
    var _apiKey;
    var _mode;
    var _API; // APIのインスタンス
    var _resultDetail;

    initialize();

    function initialize() {
        _apiEndpoint = analysisConfig.apiEndpoint;
        _serverUrl = analysisConfig.serverUrl;
        _apiKey = analysisConfig.apiKey;
        _mode = analysisConfig.mode;
        _API = getAPI();
    }

    // api取得
    function getAPI() {
        var api;
        if(_mode==1) {
            api = new Clarifai.App({'apiKey' : _apiKey});
        } else {
            api = new Clarifai.App({'apiKey' : _apiKey, 'apiEndpoint': _apiEndpoint });
        }
        return api;
    }
    
    function getResultData(resultDetail, foodlist, feedback) {
        var words = '';
        angular.forEach(resultDetail, function(value, key) {
            words += value.name + ',';
        });
        var rs = {
            'words' : words,
            'foodlist' : foodlist,
            'detail' : resultDetail,
            'feedback' : feedback
        }
        return rs;
    }

    function getTagListForfeedback(tags1, tags2) {
        var result = [];
        for (var i = 0; i < tags1.length; i++) {
            var findflg = false;
            for (var j = 0; j < tags2.length; j++) {
                if (tags1[i] == tags2[j]) {
                    findflg = true;
                    break;
                }
            }
            if (!findflg) {
                result.push(tags1[i]);
            }
        }
        return result;
    }

    function getFoodNamesFromDetail() {
        var detail = _resultDetail.detail;
        var foodNames = [];
        for (var i = 0; i < detail.length; i++) {
            foodNames[i] = detail[i].name;
        }
        return foodNames;
    }

    function getRemoveFoodNames(newFoodNames) {
        return getTagListForfeedback(getFoodNamesFromDetail(), newFoodNames);
    }

    //フィードバック情報（認識ＯＫ，ＮＧ）作成
    function getConceptfeedBack(newFoodNames) {
        // 削除した食べ物名リスト
        var removeTags = getRemoveFoodNames(newFoodNames);
        var concept = [];
        // 削除しなかった食べ物は認識成功（true）として設定
        for(var i=0; i<newFoodNames.length; i++) {
            for(var j=0; j<_resultDetail.detail.length; j++) {
                if(newFoodNames[i]==_resultDetail.detail[j].name) {
                    concept.push( { 'id' : _resultDetail.detail[j].id, 'value' : true} );
                }
            }
        }
        // 削除した食べ物は認識失敗(false)として設定
        for(var i=0; i<removeTags.length; i++) {
            for(var j=0; j<_resultDetail.detail.length; j++) {
                if(removeTags[i]==_resultDetail.detail[j].name) {
                    concept.push( { 'id' : _resultDetail.detail[j].id, 'value' : false} );
                }
            }
        }
        return concept;      
    }

    return {
        // 写真画像解析実行
        do_photoAnalysis : function(file) {
            var url = _serverUrl + file;
            var deferred = $q.defer();
            _API.models.predict(Clarifai.FOOD_MODEL, url).then(function (response) {
                console.log(response);
                var concepts = response.outputs[0].data.concepts;
                var feedback = {
                    'outputid' : response.outputs[0].id,
                    'inputid'  : response.outputs[0].input.id,
                    'imageurl' :  response.outputs[0].input.data.image.url,
                    'eventType' : 'annotation'
                }
                var foodlist;
                if(_mode==1) {
                    footlist = analysisKeyword.clarifai;
                }
                else {
                    footlist = analysisKeyword.sccai;
                }
                var rs = getResultData(concepts, footlist, feedback);
                _resultDetail = rs;
                deferred.resolve(rs);
            },
            function (err) {
                console.log(err);
            });
            return deferred.promise;
        },
        //フィードバック実行
        do_feefBack : function(newFoodNames) {
            var deferred = $q.defer();
            var feedBackConcept = getConceptfeedBack(newFoodNames);
            var imageUrl = _resultDetail.feedback.imageurl;
            var inputId = _resultDetail.feedback.inputid;
            var outputId = _resultDetail.feedback.outputid;
            var eventType = _resultDetail.feedback.eventType;
            // メモ ：
            // end_user_idとsession_idを設定しないとエラーになる（ドキュメントにはrequiredとは記載されていない）
            // エラー情報にこれを設定しろと記載されていたので、それをend_user_idとsession_idを設定している。
            // 参考url : https://clarifai.com/developer/guide/feedback#feedback
            var feedbackInfo = {
                'id': inputId,
                'data' : {
                    'concepts': feedBackConcept
                },
                'info' : {
                    'eventType' : eventType,
                    'outputId'  : outputId,
                    'end_user_id' : 'b21e1d26b3fc4f54bc57c9b1db7651ab',
                    'session_id' : 'b1b3da15b3b04bc8b47244e635b4c041'
                }
            }
            //フィードバックAPI呼び出し
            _API.models.feedback(Clarifai.FOOD_MODEL, imageUrl, feedbackInfo).then(function(response) {
                deferred.resolve(feedbackInfo);
            });
            return deferred.promise;
        }
    }
});